import { physiqueAuthInstance } from './physique.service';

export const addressService = {
  isValidPostcode: (postcode) => {
    return physiqueAuthInstance
      .get(`address/supported?postcode=${postcode}`)
      .then((res) => res.data)
      .catch((err) => err);
  },
  getAddressesByPostcode: (postcode) => {
    return physiqueAuthInstance.get(`address/search/postcode?postcode=${postcode}`).then((res) => res.data);
  },
  getAddressesByPostcodeUID: (postcodeUID) => {
    return physiqueAuthInstance.get(`address/search/postcode/${postcodeUID}`).then((res) => res.data);
  },
  searchAddress: (address) => {
    return physiqueAuthInstance.get(`address/search?address=${address}`);
  },
};
